import { Components, Theme } from '@mui/material/styles';

export const MuiOutlinedInput: Components<Theme>['MuiOutlinedInput'] = {
  styleOverrides: {
    root: {
      height: '42px',
      fontSize: '12px',
      background: 'var(--palette-background-default)',
      borderRadius: '3px !important',
      '& > fieldset': {
        borderColor: 'var(--palette-divider)',
        borderWidth: '1px !important',
      },
      '&:hover:not(.Mui-focused)': {
        '& > fieldset': {
          borderColor: 'var(--palette-action-hover)',
        },
      },
      '&.Mui-focused': {
        '& > fieldset': {
          borderColor: 'var(--palette-primary-main)',
        },
      },
    },
    /**
     Блок, чтобы не дать перекрасить инпут при автофиле
     */
    input: {
      fontSize: '12px',

      '&:-webkit-autofill': {
        WebkitBoxShadow: '0 0 0 100px var(--palette-background-default) inset',
        WebkitTextFillColor: 'var(--palette-text-primary)',
        caretColor: 'var(--palette-text-primary)',
        borderRadius: 'inherit',
      },

      '&:-webkit-autofill:hover, &:-webkit-autofill:focus, &:-webkit-autofill:active': {
        WebkitBoxShadow: '0 0 0 100px var(--palette-background-default) inset',
        WebkitTextFillColor: 'var(--palette-text-primary)',
      },

      transition: 'background-color 5000s ease-in-out 0s',
    },
  },
};
